(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quiz-concurso"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-section-type="quiz-concurso"]');

  for (const section of sections) {
    initQuizConcurso(section);
  }

  function initQuizConcurso(root) {
    const optionButtons = root.querySelectorAll('[data-quiz-option]');
    const tagsInput = root.querySelector('[data-quiz-tags-input]');
    const noteInput = root.querySelector('[data-quiz-note-input]');
    const selectedInput = root.querySelector('[data-quiz-selected-input]');
    const selectedDisplay = root.querySelector('[data-quiz-selected-display]');
    const selectedText = root.querySelector('[data-quiz-selected-text]');
    const selectionError = root.querySelector('[data-quiz-selection-error]');
    const form = root.querySelector('form.quiz-concurso__form');
    const baseTag = tagsInput ? tagsInput.value : '';

    const selectOption = (button) => {
      const optionValue = button.getAttribute('data-option-value') || '';
      const optionLabel = button.getAttribute('data-option-label') || '';

      for (const otherButton of optionButtons) {
        otherButton.setAttribute('aria-pressed', otherButton === button ? 'true' : 'false');
      }

      if (tagsInput) {
        tagsInput.value = baseTag ? baseTag + ', ' + optionValue : optionValue;
      }

      if (selectedInput) selectedInput.value = optionLabel;
      if (noteInput) noteInput.value = 'Opción seleccionada: ' + optionLabel;

      if (selectedDisplay && selectedText) {
        selectedText.textContent = optionLabel;
        selectedDisplay.hidden = false;
      }

      if (selectionError) {
        selectionError.hidden = true;
      }
    };

    for (const button of optionButtons) {
      button.addEventListener('click', function () {
        selectOption(this);
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        const hasSelectedOption = selectedInput && selectedInput.value.trim() !== '';
        if (!hasSelectedOption) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }
          if (selectionError) {
            selectionError.hidden = false;
          }
          const firstOption = root.querySelector('[data-quiz-option]');
          if (firstOption) firstOption.focus();
          return;
        }

        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.style.opacity = '0.7';
        }
      }, true);
    }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
